import { render, staticRenderFns } from "./BuildingFormChoose.vue?vue&type=template&id=ad700db8&scoped=true&"
import script from "./BuildingFormChoose.vue?vue&type=script&lang=js&"
export * from "./BuildingFormChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad700db8",
  null
  
)

export default component.exports